import React, { useState, useEffect, useRef } from "react"
import { Route, Switch, withRouter } from "react-router-dom";
import Component from "../Components"
import { inject, observer } from "mobx-react"
import config from "../config";

import beep from "../Style/beep.mp3";

function Dashboard( props ) {

	const [total, setTotal] = useState( 0 );

	const audio = new Audio( beep );

	useEffect( () => {

		const fetchData = async () => {


			if (props.Auth.id_user_group == 4) {

				await props.Data.getByStatus( `in_delivery` );

			} else {

				await props.Data.getByStatus( `new` );
				await props.Data.getByStatus( `in_progress` );
				await props.Data.getByStatus( `in_delivery` );

			}

		}

		fetchData()

		if (props.Auth.id_user_group == 4) {
			setTotal( props.Data.in_delivery.length )
		}else{
			setTotal( props.Data.new.length )
		}

	}, [props.Data] );

	useEffect( () => {
		document.title = config.title
	}, [] );

	useInterval( async () => {

		if (props.Auth.id_user_group == 4) {

			await props.Data.getByStatus( `in_delivery` );

			if (props.Data.in_delivery.length > total) {

				audio.load()
				console.log( audio.play() );

				setTotal( props.Data.in_delivery.length );

			}

		} else {

			await props.Data.getByStatus( `new` );

			if (props.Data.new.length > total) {

				audio.load()
				console.log( audio.play() );

				setTotal( props.Data.new.length );

			}

		}


	}, 10000 )


	function useInterval( callback, delay ) {
		const savedCallback = useRef();

		useEffect( () => {
			savedCallback.current = callback;
		}, [callback] );

		useEffect( () => {
			function tick() {
				savedCallback.current();
			}

			if (delay !== null) {
				let id = setInterval( tick, delay );
				return () => clearInterval( id );
			}
		}, [delay] );
	}

	return (
		<>

			<h1>Dashboard</h1>
			<p className="text-muted">Widok zamówień</p>

			<div className={"grid"}>

				{
					props.Auth.id_user_group != 4 &&
					<>
						<div className="col-md-6">
							<Component.Card.List title="Nowe" class="new"/>
						</div>
						<div className="col-md-6">
							<Component.Card.List title="W realizacji" class="in_progress"/>
						</div>
					</>
				}
			</div>

			{
				<>
					<Component.Card.List title="W dostawie" class="in_delivery"/>
				</>
			}

			<Switch>
				<Route path="/order/:id">
					<Component.Card.Bar/>
				</Route>
			</Switch>

		</>
	);

}

export default inject( 'Data', 'Auth' )( observer( Dashboard ) )
